import React from "react";
import TextFade from "../../components/CustomTexts/TextFade";
import HeroServiceItem from "../../components/Tiles/HeroServiceItem";
import { HeroServiceItemData } from "../../lib/constants";
import { EachHeroServiceItem } from "../../types";
import TextEffect from "../../components/CustomTexts/TextEffect";

const HeroServices = () => {
  return (
    <div className="overflow-x-hidden px-[5%] py-20 bg-light">
      <div className="flex w-full md:flex-row gap-10 flex-col items-center justify-between ">
        <TextFade animation="fade-right">
          <h1 className="text-[12px] sm:text-[14px] md:text-[18px] lg:text-[25px] font-bold text-center md:text-left">
            <TextEffect text2="Health, Productivity & Growth" />
          </h1>
        </TextFade>
        
        <p className="text-dark text-[13px] sm:text-[15px] md:text-[21px] text-center md:text-right md:w-[45%] w-full">
          <TextFade animation="fade-left">
            Simdozi is a leading agricultural company in West Africa,
            dedicated to enhancing the health and productivity of farmers
            and their communities through the promotion of nutritious crops. 
            <br />
          </TextFade>
        </p>
      </div>

      <div className="w-full md:flex-row flex-col flex justify-between items-center gap-20 mt-24">
        {HeroServiceItemData.items.map((item: EachHeroServiceItem, index) => (
          <HeroServiceItem
            bg={item.bg}
            image={item.image}
            title={item.title}
            description={item.description}
            url={item.url}
            key={index}
          />
        ))}
      </div>
    </div>
  );
};

export default HeroServices;
